import { dynamicRangeDiscountInputSchema } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { marketingAgentSplitZodSchema } from "@redotech/redo-storefront-widget-common/split";
import * as z from "zod";

export const startMarketingAgentTest = {
  name: "startMarketingAgentTest" as const,
  input: marketingAgentSplitZodSchema
    .pick({ cooldownHours: true, discountProclivity: true })
    .extend({
      variantTrafficPercentage: z.number().min(0).max(100),
      discountConfig: dynamicRangeDiscountInputSchema.optional(),
    }),
  output: z.object({
    splitId: z.string(),
    variantBuckets: z.array(z.number()),
  }),
};
